import React from "react";

const icons = [
  "",
  "fa-wifi",
  "fa-mug-saucer",
  "fa-display",
  "fa-chalkboard",
  "fa-file-powerpoint",
  "fa-mug-hot",
  "fa-champagne-glasses",
  "fa-video",
  "fa-calendar",
  "fa-square-parking",
  "fa-print",
  "fa-phone",
  "fa-headset",
  "fa-map-location-dot"
];

const Tag = ({ isBigTag, value, text, id, icon, alt, variant, iconSize }) => {
  const iconTag = icon ? `fa-${icon}` : icons[id];
  const className = `tag__icon fa-solid ${iconTag} ${iconSize && `fa-${iconSize}`}`;
  return (
    <aside className={`tag ${isBigTag && 'tag__big'}`}>
      <section className={`${isBigTag && 'tag__icon__shape'} ${alt && 'tag__icon__shape__2'} `}>
        <i className={className}></i>
      </section>
      <span className={"tag__text " + (variant && 'tag__variant')}>{text}</span>
      {isBigTag && <span className="tag__value">{value}</span>}
    </aside>
  );
};

export default Tag;



// WEBPACK FOOTER //
// ./src/components/Tag/index.jsx